import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const BulkPublishConfirmModal = ({
  modalOpenState,
  closeModalHandler,
  publishHandler,
  selectedCount
}) => {
  const [requestLoading, setRequestLoading] = useState(false);

  const confirmPublish = async () => {
    setRequestLoading(true);

    try {
      await publishHandler();

      // close modal AFTER publish completes
      closeModalHandler();
    } catch (err) {
      console.error(err);
    } finally {
      setRequestLoading(false);
    }
  };

  return (
    <Modal isOpen={modalOpenState} backdrop="static" size="md">
      <ModalHeader toggle={closeModalHandler}>Confirm Publish</ModalHeader>

      <ModalBody>
        <h5>
          Are you sure you want to publish <strong>{selectedCount}</strong>{' '}
          selected batch image
          {selectedCount > 1 ? 's' : ''}?
        </h5>
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={closeModalHandler}
          disabled={requestLoading}
        >
          Cancel
        </Button>

        <Button
          color="success"
          onClick={confirmPublish}
          disabled={requestLoading}
        >
          {requestLoading ? 'Publishing...' : 'Yes, Publish'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BulkPublishConfirmModal;
